import { Flex, Spacing, Text } from '@billy/design-system'
import { ReactElement, useCallback } from 'react'

import { PopularArticleItem as PopularArticleItemProps } from '../../types/popularArticleItem'
import * as Styled from './styles'

interface PopularArticleItemComponentProps extends PopularArticleItemProps {
  onClick?: (articleLink: string) => void
}

export const PopularArticleItem = ({
  description,
  Icon,
  onClick,
  title,
  url,
}: PopularArticleItemComponentProps): ReactElement => {
  const handleClick = useCallback(() => {
    onClick?.(url)
  }, [onClick, url])

  return (
    <Styled.Wrapper target="_blank" href={url} onClick={handleClick}>
      <Styled.IconWrapper>
        <Icon />
      </Styled.IconWrapper>
      <Flex flexDirection="column" gap={Spacing.S6}>
        <Text weight="medium">{title}</Text>
        <Text colorVariant="secondary">{description}</Text>
      </Flex>
    </Styled.Wrapper>
  )
}
